/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesProject_ProjectVersions.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Project Version Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, June 17, 2019 - 09:49:02 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      06/17/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const Project_ProjectVersionList = Loadable({
    loader: () => import('../containers/Project_ProjectVersions/Project_ProjectVersionListContainer'),
    loading: Loading,
});

export const Project_ProjectVersionForm = Loadable({
    loader: () => import('../containers/Project_ProjectVersions/Project_ProjectVersionEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesProject_ProjectVersions.js